import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { League, LeagueResponse } from "~types/league.ts";

export const useFetchLeague = () => {
  const request = useApi();
  const { organizationId, sport, leagueId } = useParams();

  return useQuery<League>({
    queryKey: ["leagues", sport, organizationId, leagueId],
    enabled: !!leagueId,
    queryFn: async () => {
      const response = await request<LeagueResponse>(`${sport}/o/${organizationId}/leagues/${leagueId}`);
      const league = response.data?.[0];

      if (!league) {
        throw new Error("League not found");
      }

      return league;
    },
  });
};
